import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
const publicKey = window.StripeKey;
const stripePromise = loadStripe(publicKey);
export default function BillingCheckout(props) {  
 
    return (
        <Elements stripe={stripePromise} >
            <CheckoutForm {...props} />
        </Elements>
    );
}
